import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { selectTheme, setTheme } from './store/themeSlice';
import { selectLanguage, setLanguage } from './store/languageSlice';

import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Education from './components/Education/Education';
import Footer from './components/Footer/Footer';
import ThemeToggle from './components/ThemeToggle/ThemeToggle';
import CursorBackground from './components/CursorBackground/CursorBackground';

import './App.css';

// Definito fuori da App: riferimento stabile, React non smonta/rimonta l'albero
// DOM ad ogni cambio di lingua/tema (evita conflitti con GSAP ScrollTrigger).
const HomePage = () => (
  <>
    <CursorBackground />
    <Header />
    {/* Hero fuori da main: il dither del canvas è visibile solo qui */}
    <Hero />
    {/* main e footer hanno background solido: nessun dither, piena leggibilità */}
    <main>
      <About />
      <Experience />
      <Education />
    </main>
    <Footer />
    <ThemeToggle />
  </>
);

function App() {
  const theme = useSelector(selectTheme);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme && savedTheme !== theme) {
      dispatch(setTheme(savedTheme));
    }
  }, [dispatch, theme]);

  useEffect(() => {
    document.documentElement.setAttribute('lang', language);
    localStorage.setItem('language', language);
  }, [language]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && savedLanguage !== language) {
      dispatch(setLanguage(savedLanguage));
    }
  }, [dispatch, language]);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;